// extracted by mini-css-extract-plugin
export default {"root":"ResizeHandle_root__A00cL","active":"ResizeHandle_active__kA0sn"};